import React from 'react';
import RichText from '../richText/RichText.jsx';
import { patternCardView } from './patternCards.js';
import './patternCards.css';
import SentenceRoleLegend from './SentenceRoleLegend.jsx';
const rich = 'font-serif text-book-text text-base leading-relaxed';
function MarkedSentence({ sentence, marks }) {
    const ranges = marks.map(m => ({ ...m, start: sentence.indexOf(m.anchor), end: sentence.indexOf(m.anchor) + m.anchor.length }))
        .sort((a, b) => a.start - b.start);
    const chunks = []; let cursor = 0;
    for (const m of ranges) {
        if (m.start < cursor) continue;
        chunks.push(sentence.slice(cursor, m.start));
        const missing = m.kind === 'gap' || m.kind === 'missing';
        chunks.push(missing ? <React.Fragment key={m.id}>{m.anchor}<span className="btl-pattern-gap" aria-hidden="true">⌑</span></React.Fragment>
            : <span key={m.id} className={'btl-pattern-mark btl-pattern-mark-' + m.kind + (m.role ? ' btl-pattern-role-' + m.role : '')}>{m.anchor}</span>);
        cursor = m.end;
    }
    chunks.push(sentence.slice(cursor));
    return <p className="btl-pattern-sentence">{chunks}</p>;
}
export default function PatternCards({ body, value }) {
    const view = patternCardView(body, value);
    if (!view) return <RichText text={body} className={rich} />;
    return <div className="btl-patterns" data-pattern-cards="1">
        <RichText text={view.prefix} className={rich} />
        <SentenceRoleLegend />
        <div className="btl-pattern-list">{view.rows.map((row, i) => {
            const marks = value.marks.filter(m => m.rowId === row.id);
            return <section key={row.id} className={'btl-pattern-card btl-pattern-' + value.rows[i].status} aria-label={row.name}>
                <h3 className="btl-pattern-badge">{row.label}</h3>
                <p className="btl-pattern-name">{row.name}</p>
                <MarkedSentence sentence={row.example} marks={marks} />
                <ul className="btl-pattern-reasons">{marks.map(m => <li key={m.id}>{m.label}</li>)}</ul>
                <RichText text={row.identify} className={rich} />
                <h4 className="btl-pattern-check">{value.rows[i].status === 'error' ? 'Repair and check' : 'Keep and check'}</h4>
                <RichText text={row.check} className={rich} />
            </section>;
        })}</div>
        <aside className="btl-pattern-context" aria-label="Fragment context note"><RichText text={view.context} className={rich} /></aside>
        <RichText text={view.suffix} className={rich} />
    </div>;
}
